import { countries } from "./countries";

export function findCountriesWithRoles(roles: string[] | undefined) {
  const matchingCountries: string[] = [];
  if (!roles) {
    return matchingCountries;
  }
  if (roles && roles.length === 0) {
    return matchingCountries;
  }

  countries.forEach((country) => {
    const countryRoles = country.roles;
    const matchingRoles = roles.filter((role) => countryRoles.includes(role));

    if (matchingRoles.length > 0) {
      matchingCountries.push(country.country);
    }
  });

  return matchingCountries;
}
